import { ExpCoffeeFlow } from "./LandingPageChattyFlow";
import {
  ExpFlavorFlow,
  ExpPlaceFlow,
  ExpCentralAmericaFlow,
  ExpSouthAmericaFlow,
  ExpAfricaFlow,
  ExpAsiaFlow,
  ExpMethodFlow,
  ExpDryFlow,
  ExpWashedFlow,
  ExpHoneyFlow,
  ExpRoastFlow,
  ExpRoastLightFlow,
  ExpRoastMediumFlow,
  ExpRoastHeavyFlow,
  ExpAromaFlow,
  ExpAromaFruitFlow,
  ExpAromaLandFlow,
  ExpAromaSmokedFlow,
  ExpAromaFlowerFlow,
  ExpAromaBerryFlow,
  ExpAromaNutFlow,
  ExpBodyFlow,
  ExpBodyLightFlow,
  ExpBodyMediumFlow,
  ExpBodyHeavyFlow
} from "./ProductListingPageChattyFlow";
import { ExpStoreFlow } from "./StoreListingPageChattyFlow";
import {
  FindAromaFruitFlow,
  FindAromaLandFlow,
  FindAromaSmokedFlow,
  FindAromaFlowerFlow,
  FindAromaBerryFlow,
  FindAromaNutFlow
} from "./FindAromaPageChattyFlow";
import {
  FindRoastLightFlow,
  FindRoastMediumFlow,
  FindRoastHeavyFlow
} from "./FindRoastPageChattyFlow";

export const Flows = {
  "/": ExpCoffeeFlow,
  "/aroma": ExpCoffeeFlow,
  "/roast": ExpCoffeeFlow,
  "/products": ExpFlavorFlow,
  "/products/產地": ExpPlaceFlow,
  "/products/中美洲及加勒比海地區": ExpCentralAmericaFlow,
  "/products/南美洲": ExpSouthAmericaFlow,
  "/products/非洲": ExpAfricaFlow,
  "/products/亞洲": ExpAsiaFlow,
  "/products/處理法": ExpMethodFlow,
  "/products/日曬": ExpDryFlow,
  "/products/水洗": ExpWashedFlow,
  "/products/蜜處理": ExpHoneyFlow,
  "/products/焙度": ExpRoastFlow,
  "/products/淺焙": ExpRoastLightFlow,
  "/products/中焙": ExpRoastMediumFlow,
  "/products/深焙": ExpRoastHeavyFlow,
  "/products/香氣": ExpAromaFlow,
  "/products/果香": ExpAromaFruitFlow,
  "/products/土地芬芳": ExpAromaLandFlow,
  "/products/煙熏": ExpAromaSmokedFlow,
  "/products/花香": ExpAromaFlowerFlow,
  "/products/莓果": ExpAromaBerryFlow,
  "/products/堅果": ExpAromaNutFlow,
  // "/products/醇度": ExpBodyFlow,
  // "/products/清淡": ExpBodyLightFlow,
  // "/products/適中": ExpBodyMediumFlow,
  // "/products/濃厚": ExpBodyHeavyFlow,
  "/stores": ExpStoreFlow
};
